import React from 'react'
import { Link } from 'react-router-dom';

export const HeaderPrivate = (props) => {
    
    function signOut(){
        sessionStorage.removeItem('kwt');
        window.location = "/";
    }


    return (
        <>
            <header id="header-container" className="fixed fullwidth dashboard">

                {/* <!-- Header --> */}
                <div id="header" className="not-sticky">
                    <div className="container">

                        {/* <!-- Left Side Content --> */}
                        <div className="left-side">

                            {/* <!-- Logo --> */}
                            <div id="logo">
                                <Link to="/"><img src="images/logo.png" alt="" /></Link>
                                <a href="/" className="dashboard-logo"><img src="images/logo2.png" alt="" /></a>
                            </div>

                            {/* <!-- Mobile Navigation --> */}
                            <div className="mmenu-trigger">
                                <button className="hamburger hamburger--collapse" type="button">
                                    <span className="hamburger-box">
                                        <span className="hamburger-inner"></span>
                                    </span>
                                </button>
                            </div>
                            
                            <div className="clearfix"></div>
                            {/* <!-- Main Navigation / End --> */}

                        </div>
                        {/* <!-- Left Side Content / End -->

        <!-- Right Side Content / End --> */}
                        <div className="right-side">
                            {/* <!-- Header Widget --> */}
                            <div className="header-widget">

                                {/* <!-- User Menu --> */}
                                <div className="user-menu">
                                    <div className="user-name">
                                        <span>
                                            {props.avatar && <img src={props.avatar} alt="" />}
                                            {!props.avatar && <img src="images/dashboard-avatar.jpg" alt="" />}                                            
                                        </span>
                                        Hola, {props.userName}!
                                    </div>
                                </div>
                                <a onClick={signOut} className="button border with-icon"><i className="sl sl-icon-power"></i>&nbsp;Cerrar sesión </a>
                            </div>
                            {/* <!-- Header Widget / End --> */}
                        </div>
                        {/* <!-- Right Side Content / End --> */}

                    </div>
                </div>
                {/* <!-- Header / End --> */}

            </header>
            <div className="clearfix"></div>
        </>
    )
}
